module.exports = __webpack_public_path__ + "static/media/taxijoin_05.35baa53c.png";